<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="padding: 10px;">
          <div class="actionBarStyle">
            <el-row>
              <div>
                <!-- <div style="white-space:nowrap;margin-left: 10px;margin-right: 5px;font-size: 16px;">搜索</div> -->
                <el-input placeholder="输入关键字" v-model="condition" clearable style="width:200px;">
                </el-input>
                <el-button type="primary" round @click="searchByKey">搜索</el-button>
              </div>
            </el-row>
            <el-row>
              <el-button type="primary" round @click="importStudentExcel">导入学生花名册</el-button>
              <el-button type="primary" round @click="exportExcel">导出excel文件</el-button>
              <el-button type="primary" round @click="editDialogVisible=true">添加</el-button>
              <el-tooltip class="item" effect="dark" content="不影响成绩发布" placement="top">
                <el-button type="danger" round @click="emptyAllStudents">清空</el-button>
              </el-tooltip>
            </el-row>
          </div>
        </div>

        <div style="padding: 10px;">
          <div><span style="color: red;font-size: 16px;">花名册主要用于手机端快速录入成绩时使用,如考完试后用手机誊录分数,要比直接录入电脑省时省力</span></div>
          <el-table :data="filterData" :header-cell-style="{background:'#eef1f6',color:'#606266'}" style="width: 100%"
            @sort-change="changeSort">
            <el-table-column type="index" label="序号" width="100">
            </el-table-column>
            <el-table-column prop="student_name" label="姓名">
            </el-table-column>
            <el-table-column prop="name_brief" label="简写">
            </el-table-column>
            <el-table-column prop="student_num" label="学号">
            </el-table-column>
            <!--            <el-table-column prop="grade_class" label="年级班级">
            </el-table-column> -->
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <!--                <el-button @click.native.prevent="editExamScore(scope.$index, tableData)" type="text" size="small">
                  修改
                </el-button> -->
                <el-button @click.native.prevent="delStudent(scope.$index, tableData)" type="text" size="small">
                  删除
                </el-button>
              </template>
            </el-table-column>

          </el-table>
        </div>
        <div style="text-align: center;">
          <el-pagination @current-change="handleCurrentChange" layout="total, prev, pager, next" :total="total_record"
            :page-size="pageSize">
          </el-pagination>
        </div>
      </el-col>
    </el-row>

    <el-dialog title="添加学生信息" :visible.sync="editDialogVisible">
      <el-form :model="form">
        <el-form-item label="姓名" :label-width="formLabelWidth">
          <el-input v-model="form.student_name" autocomplete="off" placeholder="输入学生姓名"></el-input>
        </el-form-item>
        <el-form-item label="学号" :label-width="formLabelWidth">
          <el-input v-model="form.student_num" autocomplete="off" placeholder="不得少于4位的字符"></el-input>
        </el-form-item>
        <!--        <el-form-item label="年级班级" :label-width="formLabelWidth">
          <el-input v-model="form.grade_class" autocomplete="off" placeholder="输入班级和年级" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-form-item> -->

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addStudentSave">保 存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    created() {
      this.examID = this.$route.params.id
      // console.log('传递过来的参数是:' + this.examID)
      this.username = this.$session.get('USERNAME') // 获取session
      this.loadData('', '')
    },
    mounted() {
      this.username = this.$session.get('USERNAME') // 获取session
      console.log('student_ist:' + this.username)
    },
    // 搜索数据
    computed: {
      filterData: function() {
        // let that = this
        // var input = this.condition && this.condition.toLowerCase()
        // var items = this.tableData
        // var items1
        // if (input) {
        //   items1 = items.filter(function(item) {
        //     return Object.keys(item).some(function(key1) {
        //       return String(item[key1])
        //         .toLowerCase()
        //         .match(input)
        //     })
        //   })
        // } else {
        //   items1 = items
        // }
        // that.currentItems = items1
        let items1 = this.tableData
        return items1
      }
    },
    data() {
      return {
        username: '',
        condition: '',
        examID: '',
        tableData: [],
        currentItems: [],
        dialogVisible: false,
        editDialogVisible: false,
        msg: '',
        selectedStudentID: '',
        position: -1,
        form: {
          student_name: '',
          student_num: '',
          score: '',
          // grade_class: '',
          id: ''
        },
        formLabelWidth: '80px',

        total_record: 0,
        pageSize: 10
      }
    },
    methods: {
      loadData(sortFieldName, sortType) {
        // console.log('加载数据')
        // let that = this

        // // 开启loading
        // const load = this.$loading({
        //   lock: true,
        //   text: 'Loading',
        //   spinner: 'el-icon-loading',
        //   background: 'rgba(0, 0, 0, 0.7)'
        // })

        // var requestUrl = '/score/web/_get_student_list.jsp'
        // this.axios.get(requestUrl, {
        //     params: {
        //       sort_field: sortFieldName,
        //       sort_type: sortType,
        //       username: that.username
        //     }
        //   }).then(function(response) {
        //     that.tableData = response.data
        //     that.currentItems = that.tableData

        //     load.close()
        //   })
        //   .catch(function(error) {
        //     console.log(error)

        //     load.close()
        //   })
        this.handleCurrentChange(1)
      },
      addStudentSave() {
        // 校验数据
        if (this.form.student_name === '') {
          this.$message.error('请输入学生姓名')
          return
        }
        // if (this.form.student_num === '') {
        //    this.$message.error('请输入学号，查询使用，可以自行设置，不得少于4位数字')
        //    return
        // }

        if (this.form.student_num.length < 4) {
          this.$message.error('学号必须是4位或者更多')
          return
        }

        // if (this.form.grade_class === '') {
        //   this.$message.error('请输入班级和年级')
        //   return
        // }

        let that = this

        var requestUrl = '/score/web/_add_student.jsp'
        this.axios.get(requestUrl, {
            params: {
              student_name: that.form.student_name,
              student_num: that.form.student_num
            }
          }).then(function(response) {
            // 更新表格的数据
            that.loadData('', '')

            that.form.student_name = ''
            that.form.student_num = ''

            that.editDialogVisible = false

            that.$message('修改成功！')
          })
          .catch(function(error) {
            console.log(error)
            that.$message(error)
            that.editDialogVisible = false
          })
      },
      // 从后台获取数据,重新排序
      changeSort(val) {
        console.log(val) // column: {…} order: "ascending" prop: "date"
        // 根据当前排序重新获取后台数据,一般后台会需要一个排序的参数
        // this.loadData(val.prop, val.order)
      },
      delStudent(index, rows) {
        let that = this
        this.selectedStudentID = this.currentItems[index].id

        console.log('this.selectedStudentID=' + this.selectedStudentID)

        this.position = index

        this.msg = '要删除"' + this.currentItems[index].student_name + '"的记录吗？'

        this.$confirm(this.msg, '重要提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var requestUrl = '/score/web/_delete_student.jsp'
          this.axios.get(requestUrl, {
              params: {
                id: that.selectedStudentID
              }
            }).then(function(response) {
              var rowsNum = that.tableData.length

              console.log('that.tableData.length=' + rowsNum)
              var i = 0
              for (; i < rowsNum; i++) {
                let tempRow = that.tableData[i]
                // console.log(tempRow.id)

                if (tempRow.id === that.selectedStudentID) {
                  that.tableData.splice(i, 1)
                  // that.currentItems.splice(that.position, 1)
                  // console.log('#########################')
                  break
                }
              }

              that.$message('删除成功！')
            })
            .catch(function(error) {
              console.log(error)
            })
        }).catch(() => {

        })
      },
      indexMethod(index) {
        return this.filterData.length - index
      },
      emptyAllStudents() {
        let that = this

        this.msg = '要清除花名册中所有的数据吗？'

        this.$confirm(this.msg, '重要提示', {
          confirmButtonText: '清除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var requestUrl = '/score/web/_delete_all_students.jsp'
          this.axios.get(requestUrl, {
              params: {
                username: that.$session.get('USERNAME')
              }
            }).then(function(response) {
              if (response.data.result === '1') {
                that.filterData.splice(0, that.filterData.length)
                that.$message('删除成功！')
                that.$router.push('/student_list')
              } else {
                that.$message.error('删除失败！')
              }
            })
            .catch(function(error) {
              console.log(error)
            })
        }).catch(() => {

        })
      },
      exportExcel() {
        let that = this
        this.$confirm('您现在要导出学生花名册吗?', '提示', {
          confirmButtonText: '立即导出',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.exportExcelAction()

        }).catch(() => {})
      },
      exportExcelAction() {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_export_all_student_to_excel.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.$session.get('USERNAME')
            }
          }).then(function(response) {
            // console.log(response.data.file_name)

            var url = '/score' + response.data.file_name
            // that.excel_file_url = url
            // that.downloadExcelDialogVisible = true
            window.open(url)

            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })
      },
      handleCurrentChange(currentPage) {
        console.log('加载数据')
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_get_student_list.jsp'
        this.axios.get(requestUrl, {
            params: {
              sort_field: '',
              sort_type: '',
              username: that.username,
              current_page: currentPage,
              page_size: that.pageSize,
              condition: that.condition
            }
          }).then(function(response) {
            that.tableData = response.data.students
            that.currentItems = that.tableData
            that.total_record = response.data.total_record

            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })
      },
      searchByKey() {
        this.handleCurrentChange(1)
      },
      importStudentExcel() {
        this.$router.push('/student_import_anyfile')
      }
    }
  }
</script>

<style>
  .searchStyle {
    display: flex;
    width: 400px;
    align-items: center;

  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }
</style>


// WEBPACK FOOTER //
// src/components/student_list.vue